import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { HOSPITAL } from "../data/site";

export const FloatingButtons = () => {
  const waMsg = encodeURIComponent(
    "Hi, I would like to know more about Family HealthCare Hospital."
  );
  return (
    <div
      data-testid="floating-actions"
      className="fixed right-4 bottom-5 md:right-6 md:bottom-6 z-50 flex flex-col gap-3"
    >
      <a
        href={`https://wa.me/${HOSPITAL.whatsapp}?text=${waMsg}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        data-testid="float-whatsapp-btn"
        className="group flex items-center gap-3 bg-[#25D366] hover:bg-[#1FB855] text-white pl-4 pr-5 py-3 rounded-full shadow-xl transition-all hover:scale-[1.03]"
      >
        <MessageCircle size={20} />
        <span className="hidden sm:inline text-sm font-semibold">WhatsApp</span>
      </a>
      <a
        href={`tel:${HOSPITAL.phoneDial}`}
        aria-label="Call hospital"
        data-testid="float-call-btn"
        className="fhc-pulse group flex items-center gap-3 bg-brand-maroon hover:bg-brand-maroonDark text-white pl-4 pr-5 py-3 rounded-full shadow-xl transition-all hover:scale-[1.03]"
      >
        <Phone size={20} />
        <span className="hidden sm:inline text-sm font-semibold">Call now</span>
      </a>
    </div>
  );
};

export default FloatingButtons;
